import Component from '@glimmer/component';
import { sub } from 'date-fns';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task, timeout, waitForProperty, didCancel } from 'ember-concurrency';
import normalizeIdentifier from 'ember-stereo/-private/utils/normalize-identifier';
export default class PlayerComponent extends Component {
  @service stereo;
  @service clock;
  @service intl;
  @service router;
  @service playback;
  @service store;

  @tracked expanded = false;
  @tracked openPlaylist = this.args.openPlaylist;

  get loadedSound() {
    return this.stereo.findSound(this.args.identifier);
  }

  get loadedMetadata() {
    if (this.args.identifier) {
      return this.stereo.metadataCache.find(this.args.identifier);
    } else {
      return {};
    }
  }

  get normalizedIdentifier() {
    if (this.args.identifier !== '') {
      return normalizeIdentifier(this.args.identifier);
    } else {
      return this.args.identifier;
    }
  }

  @task
  *autoPlay() {
    yield timeout(1000);
    yield this.stereo.playTask.perform(this.args.identifier, {
      useConnections: this.useConnections,
    });
  }

  @action 
  togglePlaylist() {
    this.openPlaylist = !this.openPlaylist;
  }
}
